// Stub functions for Bill Requests and Lockbox functionality
// These are used by the MortgageCoProcessing store module

export const MortgageCompanyPaymentsData = [];
export const lockBox = [];
